export const translations = {
  en: {
    featured: "Featured",
    pricePerPerson: "/person",
    moreDetails: "More details",
    lessDetails: "Less details",
    bookNow: "Book now",
    includes: "Includes",
    errors: {
      loadServices: "Error loading services"
    },
    tryAgain: "Try again",
    heroTitle: "Discover Unique Experiences",
    heroSubtitle: "Book exclusive activities with local experts",
    contactUs: "Contact Us",
    ourExperiences: "Our Experiences",
    searchPlaceholder: "Search experiences...",
    filters: "Filters",
    category: "Category",
    priceRange: "Price range: ${min} - ${max} USD",
    sortBy: "Sort by",
    sortOptions: {
      price_asc: "Price: Low to High",
      price_desc: "Price: High to Low",
      featured: "Featured",
      rating: "Rating"
    },
    noResultsTitle: "No results found",
    noResultsMessage: "Try adjusting your search or filters to find what you're looking for",
    resetFilters: "Reset filters",
    providerTitle: "Are you a service provider?",
    providerSubtitle: "Join our platform and reach thousands of travelers",
    registerProvider: "Register as provider",
    requestInfo: "Request info",
    company: "Company",
    ourPhilosophy: "Our philosophy",
    assistance: "Assistance",
    madeIn: "Made with ❤️ around the world"
  },
  es: {
    featured: "Destacado",
    pricePerPerson: "/persona",
    moreDetails: "Más detalles",
    lessDetails: "Menos detalles",
    bookNow: "Reservar ahora",
    includes: "Incluye",
    errors: {
      loadServices: "Error al cargar los servicios"
    },
    tryAgain: "Reintentar",
    heroTitle: "Descubre Experiencias Únicas",
    heroSubtitle: "Reserva actividades exclusivas con expertos locales",
    contactUs: "Contáctanos",
    ourExperiences: "Nuestras Experiencias",
    searchPlaceholder: "Buscar experiencias...",
    filters: "Filtros",
    category: "Categoría",
    priceRange: "Rango de precio: ${min} - ${max} USD",
    sortBy: "Ordenar por",
    sortOptions: {
      price_asc: "Precio: Menor a Mayor",
      price_desc: "Precio: Mayor a Menor",
      featured: "Destacados",
      rating: "Calificación"
    },
    noResultsTitle: "No se encontraron resultados",
    noResultsMessage: "Intenta ajustar tu búsqueda o filtros para encontrar lo que buscas",
    resetFilters: "Restablecer filtros",
    providerTitle: "¿Eres un proveedor de servicios?",
    providerSubtitle: "Únete a nuestra plataforma y llega a miles de viajeros",
    registerProvider: "Registrarse como proveedor",
    requestInfo: "Solicitar información",
    company: "Compañía",
    ourPhilosophy: "Nuestra filosofía",
    assistance: "Asistencia",
    madeIn: "Hecho con ❤️ en todo el mundo"
  }
};

export const languageOptions = [
  { code: 'es', name: 'Español' },
  { code: 'en', name: 'English' }
];